import store from "./player-store"
import { goToSlide } from "./player-navigation"
import { progressBar } from "./selectors"
import { getSlideContainerWidth } from "./dimensions"
import { skipAd } from "../ads/slideview/interstitial"

const slidesLoadedBar = $(".progress-container")

const getSlideAtCursor = (event) => {
  const adjustedCursorX = getAdjustedCursorX(event)
  let barWidth = getSlideContainerWidth()

  // Math.max(1, ...) b/c should never show slide 0
  return Math.max(1, Math.ceil((adjustedCursorX / barWidth) * store.totalSlides))
}

const getAdjustedCursorX = (event) => {
  const barOffsetX = progressBar.offset().left

  return event.pageX - barOffsetX
}

const handleProgressBarClick = (e) => {
  if (store.isShowingAd) {
    skipAd()
  }
  const slideAtCursor = getSlideAtCursor(event)
  const position = slideAtCursor - 1
  if (position === store.index) {
    return
  }
  goToSlide(position, true)
}

const bindListeners = () => {
  progressBar.on("click", function () {
    handleProgressBarClick()
  })
}

export const updateProgressBar = () => {
  let progress = ((store.index + 1) / store.totalSlides) * 100
  slidesLoadedBar.width(progress + "%")
}

export const initializeProgressBar = () => {
  bindListeners()
  updateProgressBar()
}
